import { BotaoComTexto, EstadoVazio } from '@digix-ui/componentes'

import Carregamento from '@/components/ui/Carregamento'
import { useNotificacoes } from '@/contexts/contexto-notificacoes'

import { CartaoDeNotificacao } from '../CartaoDeNotificacao'

import classes from './styles.module.scss'

interface PopupDeNotificacoesProps {
  id: string
  aoFechar: () => void
}

export function PopupDeNotificacoes({
  id,
  aoFechar,
}: PopupDeNotificacoesProps): JSX.Element {
  const {
    notificacoes,
    carregando,
    carregandoMais,
    erro,
    existemNaoVisualizadas,
    podeCarregarMais,
    recarregarNotificacoes,
    carregarMaisNotificacoes,
    marcarTodasComoLidas,
  } = useNotificacoes()

  const exibindoListagem = !carregando && !erro && notificacoes.length > 0

  function renderizarConteudo(): JSX.Element {
    if (carregando) {
      return (
        <div className={classes.estado}>
          <Carregamento tamanho={40} />
        </div>
      )
    }

    if (erro) {
      return (
        <div className={classes.estado}>
          <EstadoVazio
            cor="erro"
            icone="fa-regular fa-circle-exclamation"
            mensagem="Erro ao carregar as notificações"
            descricao="Não foi possível carregar as notificações no momento."
          />
          <BotaoComTexto
            tipo="button"
            visual="contorno"
            cor="primaria"
            onClick={recarregarNotificacoes}
          >
            Tentar novamente
          </BotaoComTexto>
        </div>
      )
    }

    if (!notificacoes.length) {
      return (
        <div className={classes.estado}>
          <EstadoVazio
            icone="fa-regular fa-check"
            mensagem="Sem notificações"
            descricao="Você não possui notificações."
          />
        </div>
      )
    }

    return (
      <ul className={classes.lista}>
        {notificacoes.map(notificacao => (
          <CartaoDeNotificacao
            key={notificacao.id}
            notificacao={notificacao}
            aoFechar={aoFechar}
          />
        ))}
      </ul>
    )
  }

  return (
    <div
      id={id}
      className={classes.popup}
      role="dialog"
      aria-label="Notificações"
    >
      <header className={classes.cabecalho}>
        <h2 className={classes.titulo}>Notificações</h2>

        {exibindoListagem && existemNaoVisualizadas && (
          <button
            type="button"
            className={classes.acaoDeTexto}
            onClick={marcarTodasComoLidas}
          >
            Marcar todas como vistas
          </button>
        )}
      </header>

      <div className={classes.corpo}>{renderizarConteudo()}</div>

      {exibindoListagem && podeCarregarMais && (
        <footer className={classes.rodape}>
          <button
            type="button"
            className={classes.acaoDeTexto}
            onClick={carregarMaisNotificacoes}
            disabled={carregandoMais}
          >
            {carregandoMais ? 'Carregando...' : 'Carregar Mais'}
          </button>
        </footer>
      )}
    </div>
  )
}
